export default __webpack_public_path__ + "static/media/classes.32da5d8e.jpg";